<template>
  <footer
    class="
      SisrFooter
      bg-primary
      text-gray-800
      d-flex
      flex-column
      align-items-center
      p-2
    "
  >
    <span class="d-flex align-items-center justify-content-center mb-3">
      <div class="icons mr-1">
        <font-awesome-icon icon="book-reader" class="primary-icon" />
      </div>
      <a
        :href="`${URL_APPLICATIVO}/${NOME_FILE_MANUALE_USO}`"
        target="_blank"
        class="Bolder"
        ><u>{{ LABEL.LAYOUT.MANUALE }}</u></a
      >
    </span>
    <span class="d-flex align-items-center justify-content-center">
      <span class="FooterImgLogo mr-2">
        <LogoCsaMed :darkMode="darkMode" />
      </span>
      <p class="mb-0 font-weight-bold">{{ LABEL.LAYOUT.NET4MARKET }}</p>
    </span>
  </footer>
</template>

<script>
import { darkModeMixin } from "../../libs/mixins/application";
import LABEL from "../../libs/utils/label";
import {
  URL_APPLICATIVO,
  NOME_FILE_MANUALE_USO,
} from "../../libs/utils/commons";
export default {
  data() {
    return {
      LABEL,
      URL_APPLICATIVO,
      NOME_FILE_MANUALE_USO,
    };
  },
  mixins: [darkModeMixin],
};
</script>
